import { render, staticRenderFns } from "./RelatedRequests.vue?vue&type=template&id=03aa1a94"
import script from "./RelatedRequests.vue?vue&type=script&lang=js"
export * from "./RelatedRequests.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports